import { Rect } from "react-konva";

interface PreviewBoxProps {
  /** Percent xywh, top-left origin — the same frame as a PredictedRectangle. */
  bbox: { x: number; y: number; width: number; height: number };
  color: string;
  imageWidth: number;
  imageHeight: number;
  stageScale: number;
}

/**
 * A box Robopipe Vision has just emitted, before the turn has finished.
 *
 * Deliberately not an `Annotation`. These arrive one at a time out of a JSON
 * document that is still being written, and putting them into the canvas state
 * would give the labeller an undo stack with sixty entries in it, a dirty flag
 * that flickers, and a selection that clears under their cursor. They live on
 * their own non-listening layer instead and are thrown away the moment the real
 * result lands.
 *
 * Styled like `DrawingRegion` rather than like a finished box, because that is
 * what it is: something being drawn. The dash scales with the stage so it reads
 * the same at every zoom, and `animate-in` is not available here — Konva is
 * canvas, not DOM — so the arrival animation is simply the box appearing.
 */
export const PreviewBox = ({
  bbox,
  color,
  imageWidth,
  imageHeight,
  stageScale,
}: PreviewBoxProps) => (
  <Rect
    x={(bbox.x / 100) * imageWidth}
    y={(bbox.y / 100) * imageHeight}
    width={(bbox.width / 100) * imageWidth}
    height={(bbox.height / 100) * imageHeight}
    stroke={color}
    strokeWidth={2}
    strokeScaleEnabled={false}
    dash={[6 / stageScale, 3 / stageScale]}
    fill={`${color}1A`}
    listening={false}
    perfectDrawEnabled={false}
  />
);
